"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerPageInvoice = void 0;
const firestore_1 = require("firebase/firestore");
const react_1 = __importStar(require("react"));
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const OverlayTrigger_1 = __importDefault(require("react-bootstrap/OverlayTrigger"));
const Tooltip_1 = __importDefault(require("react-bootstrap/Tooltip"));
const configContext_1 = require("../../context/configContext");
const bookingFactory = __importStar(require("../../models/helper/bookingFactory"));
const bookingQueries_1 = require("../../models/queries/bookingQueries");
const useFirestore_1 = require("../../utils/useFirestore");
const IconHelpOutline_1 = require("../icons/IconHelpOutline");
const ManagerBookingTable_1 = require("../manager-tables/ManagerBookingTable");
const Spinner_1 = require("../spinner/Spinner");
/**
 * Shows all bookings that must be invoiced.
 */
const ManagerPageInvoice = (props) => {
    const [bookings, setBookings] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const config = (0, configContext_1.useConfig)();
    const firestore = (0, useFirestore_1.useFirestore)();
    (0, react_1.useEffect)(() => {
        setIsLoading(true);
        const unsubscribeQuery = (0, firestore_1.onSnapshot)((0, bookingQueries_1.bookingQueryAllToInvoice)(firestore, config.tenantId), (querySnapshot) => {
            const bookings = bookingFactory.createAllFromFirestore(querySnapshot.docs, config);
            setBookings(bookings);
            setIsLoading(false);
        }, (err) => {
            console.error(err);
        });
        return () => unsubscribeQuery();
    }, []);
    let content;
    if (isLoading) {
        content = react_1.default.createElement(Spinner_1.Spinner, { className: "my-3 mx-auto" });
    }
    else if (bookings) {
        content = (react_1.default.createElement(ManagerBookingTable_1.ManagerBookingTable, { bookings: bookings, show: {
                date: true,
                startTime: true,
                endTime: true,
                resource: true,
                contactName: true,
                contactOrg: true,
                bookingStatus: true,
                invoiceStatus: true,
                invoiceDate: false,
                dueDate: false,
                balance: true,
            } }));
    }
    else {
        content = "Fehler beim Laden der Buchungen. Bitte Support kontaktieren.";
    }
    return (react_1.default.createElement(Container_1.default, { fluid: true, className: "manager-page-invoice main-content d-flex flex-column" },
        react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between mt-4 mb-4" },
            react_1.default.createElement("h1", { className: "text-nowrap mb-0" },
                "Fakturieren",
                react_1.default.createElement(OverlayTrigger_1.default, { placement: "right", overlay: react_1.default.createElement(Tooltip_1.default, { id: "title-tooltip" }, "Buchungen, die vorbei sind und f\u00FCr die eine Rechnung geschickt werden muss.") },
                    react_1.default.createElement("span", { className: "text-secondary pl-1 no-print", style: { fontSize: "20px" } },
                        react_1.default.createElement(IconHelpOutline_1.IconHelpOutline, null))))),
        content));
};
exports.ManagerPageInvoice = ManagerPageInvoice;
